package com.trevorwiebe.timesheet.core.domain.dto

import com.trevorwiebe.timesheet.core.domain.model.OwnerOperator
import kotlinx.serialization.Serializable

@Serializable
data class OwnerOperatorDto(
    val contactName: String = "",
    val companyName: String = "",
    val address: String = "",
    val phone: String = "",
    val email: String = "",
    val notes: String = "",
    val basePayPercent: Double? = null,
    val active: Boolean = true,
    val deleted: Boolean = false,
    val order: Int = 0,
)

fun OwnerOperatorDto.toOwnerOperator(id: String) = OwnerOperator(
    id = id,
    contactName = contactName,
    companyName = companyName,
    address = address,
    phone = phone,
    email = email,
    notes = notes,
    basePayPercent = basePayPercent,
    active = active,
    deleted = deleted,
    order = order,
)

fun OwnerOperator.toOwnerOperatorDto() = OwnerOperatorDto(
    contactName = contactName,
    companyName = companyName,
    address = address,
    phone = phone,
    email = email,
    notes = notes,
    basePayPercent = basePayPercent,
    active = active,
    deleted = deleted,
    order = order,
)
